import { c as _c } from "react/compiler-runtime";
import { MemberName, NothingToDoAlert } from "@components/table/members/remove-xg-seat/remove-xg-seat-list";
import { isWorkspaceAdmin, WORKSPACE_ROLES_WITHOUT_SEAT } from "@components/table/members/remove-xg-seat/remove-xg-seat-utils";
import { useRefetchMember } from "@components/table/members/remove-xg-seat/use-refetch-member";
import { CircularProgress, Radio, RadioGroup, Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { formatUserRoleType, userRoleDescription } from "@utils/data-display";
/** Lets the user choose the workspace role of an admin, who cannot keep it without a seat */
function NewWorkspaceRole(t0) {
  const $ = _c(14);
  const {
    member,
    newRole,
    onNewRoleChange
  } = t0;
  let t1;
  if ($[0] !== member) {
    t1 = <MemberName member={member} />;
    $[0] = member;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const name = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: 2
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== name) {
    t3 = <Text variant="bodyM">{name} is an admin in the workspace, which needs a Sphere XG seat. Choose the workspace role {name} gets instead.</Text>;
    $[3] = name;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onNewRoleChange) {
    t4 = (_, role) => onNewRoleChange(role);
    $[5] = onNewRoleChange;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = WORKSPACE_ROLES_WITHOUT_SEAT.map(_temp);
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== newRole || $[9] !== t4) {
    t6 = <RadioGroup label="New workspace role" value={newRole} onChange={t4}>{t5}</RadioGroup>;
    $[8] = newRole;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <Stack sx={t2}>{t3}{t6}</Stack>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}

/**
 * Last step of taking a Sphere XG seat away from a member: an admin in the workspace has to be given a
 * workspace role that needs no seat, i.e. viewer or no workspace role at all. The member is fetched
 * again first, since the previous steps may have changed their workspace role.
 */
function _temp(role_0) {
  return <Radio key={role_0} value={role_0} label={<Stack component="span"><Text variant="bodyM" component="span">{formatUserRoleType(role_0)}</Text><Text variant="bodyS" component="span" sx={{
      color: "text.secondary"
    }}>{userRoleDescription(role_0)}</Text></Stack>} />;
}
export function RemoveXgSeatWorkspaceRoleStep(props) {
  const $ = _c(14);
  const {
    member
  } = props;
  const isLoading = useRefetchMember(member.identity);
  if (isLoading) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Stack sx={{
        alignItems: "center",
        py: 3
      }}><CircularProgress size="2rem" dataTestId="remove-xg-seat-loading" /></Stack>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== member) {
    t0 = <MemberName member={member} />;
    $[1] = member;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const name = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: 2
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== member || $[5] !== name || $[6] !== props) {
    t2 = isWorkspaceAdmin(member) ? <NewWorkspaceRole {...props} /> : <NothingToDoAlert message={<>{name} is not an admin in the workspace, so their workspace role does not change.</>} />;
    $[4] = member;
    $[5] = name;
    $[6] = props;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <strong>Remove seat</strong>;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== name) {
    t4 = <Text variant="bodyM">Select {t3} to take the Sphere XG seat away from{" "}{name}.</Text>;
    $[9] = name;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t4) {
    t5 = <Stack sx={t1}>{t2}{t4}</Stack>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}